// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9e0c2296","453":"cfb4faf6","455":"7c0d695f","921":"05e10fb9","977":"ffdb9f8c"}[chunkId] + ".chunk.js";
};